var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonutChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C34.6072 85 26.8703 82.8021 20.1563 78.6526C13.4423 74.5031 8.01645 68.5659 4.48673 61.5063C0.957002 54.4468 -0.537126 46.5438 0.171765 38.6829C0.880655 30.822 3.76456 23.3138 8.50032 16.9996C13.2361 10.6854 19.6366 5.81471 26.9846 2.93331C34.3327 0.0519008 42.3379 -0.726381 50.1034 0.68567C57.8689 2.09772 65.0877 5.64431 70.951 10.928C76.8144 16.2118 81.0905 23.0239 83.3003 30.601L67.999 35.0635C66.618 30.328 63.9455 26.0706 60.2811 22.7684C56.6167 19.4662 52.1051 17.2497 47.2519 16.3672C42.3987 15.4847 37.3957 15.9711 32.8033 17.7719C28.211 19.5727 24.2109 22.6168 21.2512 26.563C18.2915 30.5091 16.4891 35.2016 16.0461 40.1144C15.603 45.0272 16.5368 49.9664 18.7428 54.3784C20.9488 58.7904 24.3398 62.501 28.5358 65.0943C32.7319 67.6877 37.5672 69.0613 42.5 69.0613L42.5 85Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9244 29.3805C85.6949 37.9173 85.6918 47.1121 82.9154 55.647C80.1391 64.1819 74.732 71.6188 67.4692 76.8917L58.1244 64.0205C62.669 60.721 66.0525 56.0674 67.7898 50.7267C69.5271 45.386 69.5291 39.6324 67.7954 34.2905L82.9244 29.3805Z",
    fill: "#B9E6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4801 76.8838C60.2189 82.1591 51.4741 85.0002 42.499 85L42.4994 69.1264C48.1223 69.1266 53.601 67.3466 58.1501 64.0416L67.4801 76.8838Z",
    fill: "#C8C8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutChart);
export default __webpack_public_path__ + "static/media/donut-chart.ca3e41c38b68d99e46a76044d12cc551.svg";
export { ForwardRef as ReactComponent };